import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeComponent } from './views/home/home.component';
import { DramHeroComponent } from './components/dram-hero/dram-hero.component';
import { CreditSimulatorComponent } from './components/credit-simulator/credit-simulator.component';
import { FormsModule } from '@angular/forms';
import { ButtonCreditoComponent } from './shared/button-credito/button-credito.component';
import { ReactiveTextComponent } from './components/reactive-text/reactive-text.component';
import { ProcessAnimationsBannerComponent } from './components/process-animations-banner/process-animations-banner.component';
import { DramSlidesComponent } from './components/dram-slides/dram-slides.component';
import { GrowAlliesPhraseComponent } from './components/grow-allies-phrase/grow-allies-phrase.component';
import { PrestamoBarComponent } from './shared/prestamo-bar/prestamo-bar.component';
import { LastReelsIgComponent } from './components/last-reels-ig/last-reels-ig.component';
import { GrowTodayPhraseComponent } from './components/grow-today-phrase/grow-today-phrase.component';
import { LottieModule } from 'ngx-lottie';
import { DramCapitalBannerComponent } from './components/dram-capital-banner/dram-capital-banner.component';
import { DramFooterComponent } from './shared/dram-footer/dram-footer.component';
import { TerminosCondicionesComponent } from './views/terminos-condiciones/terminos-condiciones.component';
import { AvisoPrivacidadComponent } from './views/aviso-privacidad/aviso-privacidad.component';
import { HeaderComponent } from './shared/header/header.component';
import { SpheresParallaxComponent } from './shared/parallax-w-privacy-terms/parallax-w-privacy-terms.component';
import { NgxCurrencyModule } from 'ngx-currency';
import { HttpClientModule } from '@angular/common/http';

export function playerFactory() {
    return import('lottie-web');
}

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    DramHeroComponent,
    CreditSimulatorComponent,
    ButtonCreditoComponent,
    ReactiveTextComponent,
    ProcessAnimationsBannerComponent,
    DramSlidesComponent,
    GrowAlliesPhraseComponent,
    PrestamoBarComponent,
    LastReelsIgComponent,
    GrowTodayPhraseComponent,
    DramCapitalBannerComponent,
    DramFooterComponent,
    TerminosCondicionesComponent,
    AvisoPrivacidadComponent,
    HeaderComponent,
    SpheresParallaxComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    BrowserAnimationsModule,
    NgxCurrencyModule,
    LottieModule.forRoot({ player: playerFactory }),
    HttpClientModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
